import { GET_PRODUCT_REPORT_SUMMARY_REQUEST,
    GET_PRODUCT_REPORT_SUMMARY_SUCCESS,
    GET_PRODUCT_REPORT_SUMMARY_FAILURE,
    RESET_PRODUCT_REPORT_SUMMARY,
    GET_PRODUCT_HEADER_REPORT_REQUEST,
    GET_PRODUCT_HEADER_REPORT_SUCCESS,
    GET_PRODUCT_HEADER_REPORT_FAILURE,
    RESET_HEADER_REPORT,
    GET_PRODUCT_ANY_OTHER_DATA_REQUEST,
    GET_PRODUCT_ANY_OTHER_DATA_SUCCESS,
    GET_PRODUCT_ANY_OTHER_DATA_FAILURE,
    RESET_PRODUCT_ANY_OTHER_DATA} from './constants';
import axios from 'axios';
import { onRequest,
    onSuccess,
    onError,
    getResponseData } from '../../utils/helper';
import { getBaseUrl, productLinks } from '../../utils/links';
let CancelToken = axios.CancelToken;

// action to get report summary
export let getProductReportSummaryCancelToken = undefined;
export const getProductReportSummary = (token,
    productId) => {
    return dispatch => {
        if (getProductReportSummaryCancelToken) getProductReportSummaryCancelToken();
        dispatch(onRequest(GET_PRODUCT_REPORT_SUMMARY_REQUEST));
        let url = `${getBaseUrl()}${productLinks.reportSummary(productId)}`,
            options = {
                url,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                cancelToken: new CancelToken((c) => getProductReportSummaryCancelToken = c)
            };
        return axios(options)
            .then(response => {
                let successData = getResponseData(response);
                if (successData) {
                    dispatch(onSuccess(GET_PRODUCT_REPORT_SUMMARY_SUCCESS, {
                        productId,
                        summary: successData
                    }));
                } else {
                    dispatch(onError(GET_PRODUCT_REPORT_SUMMARY_FAILURE, response.data.errors));
                }
                return successData;
            })
            .catch(error => {
                dispatch(onError(GET_PRODUCT_REPORT_SUMMARY_FAILURE, error));
                return false;
            })
    }
}

export const resetProductReportSummary = () => onSuccess(RESET_PRODUCT_REPORT_SUMMARY);

// function to get header wise report
export let getHeaderWiseReportCancelToken = undefined;
export const getHeaderWiseReport = (token,
    productId,
    headerId) => {
    return dispatch => {
        if (getHeaderWiseReportCancelToken) getHeaderWiseReportCancelToken();
        dispatch(onRequest(GET_PRODUCT_HEADER_REPORT_REQUEST));
        let url = `${getBaseUrl()}${productLinks.headerReport(productId, headerId)}`,
            options = {
                url,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                cancelToken: new CancelToken((c) => getHeaderWiseReportCancelToken = c)
            };
        return axios(options)
            .then(response => {
                let successData = getResponseData(response);
                if (successData) {
                    dispatch(onSuccess(GET_PRODUCT_HEADER_REPORT_SUCCESS, {
                        headerId,
                        reportData: successData
                    }));
                } else {
                    dispatch(onError(GET_PRODUCT_HEADER_REPORT_FAILURE, response.data.errors));
                }
                return successData;
            })
            .catch(error => {
                dispatch(onError(GET_PRODUCT_HEADER_REPORT_FAILURE, error));
                return false;
            })
    }
}

// function to reset header report
export const resetHeaderReport = () => onSuccess(RESET_HEADER_REPORT);

// getting anyother reports
export let getAnyOtherProductCancelToken = undefined;
export const getAnyOtherProduct = (token,
    productId,
    headerId,
    questionId,
    page = 1,
    answerValue = '',
    optionId) => {
        return dispatch => {
            if (getAnyOtherProductCancelToken) getAnyOtherProductCancelToken();
            dispatch(onRequest(GET_PRODUCT_ANY_OTHER_DATA_REQUEST, { productId,
            headerId,
            questionId,
            answerValue,
            optionId }));
            let url = `${getBaseUrl()}${productLinks.anyOther(productId, headerId, questionId, optionId)}`,
                options = {
                    url,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    params: {
                        page
                    },
                    cancelToken: new CancelToken((c) => getAnyOtherProductCancelToken = c)
                };
            return axios(options)
                .then(response => {
                    let successData = getResponseData(response);
                    if (successData) {
                        dispatch(onSuccess(GET_PRODUCT_ANY_OTHER_DATA_SUCCESS, successData));
                    } else {
                        dispatch(onError(GET_PRODUCT_ANY_OTHER_DATA_FAILURE, response.data.error));
                    }
                    return successData
                })
                .catch(_ => {
                    dispatch(onError(GET_PRODUCT_ANY_OTHER_DATA_FAILURE, _));
                    return false;
            });
        }
}

// function to reset any other
export const resetAndHideProductAnyOther = () => onSuccess(RESET_PRODUCT_ANY_OTHER_DATA)